<template>
  <!-- product-bg -->
  <section class="product-detail-bg" style="padding-top:50px;">

    <div class="container">
      <div class="bdr">
        <ul>
          <li>主页</li>
          <li>/</li>
          <li>商城</li>
          <li>/</li>
          <li><span>商品详情</span></li>
        </ul>
      </div>
      <div class="row">
        <!-- left side -->
        <div class="col-sm-6 col-md-6">
          <!-- product gallery -->
          <div id="home-slider3" class="carousel fadein carousel-fade" data-ride="carousel">
            <!-- .home-slider -->
            <div class="carousel-inner">
              <!--                            <div class="item active">-->
              <!--                                <div class="caption">-->
              <!--                                    <img src="/images/Products/1.jpg" alt="qoute-icon">-->
              <!--                                </div>-->
              <!--                            </div>-->

              <div class="item" v-for="(item, index) in product.imgs" :class="index===0 ? 'active' : ''">
                <div class="caption">
                  <img :src="'https://img.hogonmr.cn/product/'+item+'?imageView2/0/w/500'" alt="qoute-icon">
                </div>
              </div>

              <ul class="carousel-indicators">

                <li data-target="#home-slider3" v-for="(item, index) in product.imgs" :data-slide-to="index"
                    :class="index===0 ? 'active' : ''">
                  <img :src="'https://img.hogonmr.cn/product/'+item+'?imageView2/0/w/100'" alt="qoute-icon">
                </li>

              </ul>
            </div>
            <!-- /.home-slider -->
          </div>
          <!-- / product gallery -->
        </div>
        <!-- left side -->
        <!-- right side -->
        <div class="col-sm-6 col-md-6">
          <!-- .pro-text -->
          <div class="pro-text product-detail">
            <!-- /.pro-img -->
            <a href="#">
              <h4>{{ product.title }} {{ product.subtitle }}</h4>
            </a>
            <div class="star2">
              <ul>
                <li class="red-color"><i class="fa fa-star" aria-hidden="true"></i></li>
                <li class="red-color"><i class="fa fa-star" aria-hidden="true"></i></li>
                <li class="red-color"><i class="fa fa-star" aria-hidden="true"></i></li>
                <li class="red-color"><i class="fa fa-star" aria-hidden="true"></i></li>
                <li><i class="fa fa-star" aria-hidden="true"></i></li>
                <li><a href="#">10472 浏览次数</a></li>
                <li><a href="#"> 已售 2391</a></li>
              </ul>
            </div>
            <p class="price-detail" style="color:#EF5223;">¥{{ product.price }} <span>¥{{ product.origin_price }}</span>
            </p>
            <p>
              专为都市生活而打造轻奢个性服饰鞋履 ，将具功能性的实用元素与慵懒的优雅风格巧妙融合。以精致的工艺凸显非凡的品质。创新、精致与多变，每一件 HOGONMR 时尚用品均选用上好材质精心打造，堪为真正的奢华创作。
            </p>
            <ul class="short-ul">
              <li>当季新款</li>
              <li>HOGON MR经典元素</li>
              <li>专注于引领潮流高街时尚</li>
            </ul>
            <div class="size">
              <p>尺寸 *</p>
              <div class="select-option">
                <select>
                  <option value="28">请选择</option>
                </select>
              </div>
            </div>
            <div class="size">
              <p>颜色 *</p>
              <div class="select-option">
                <select>
                  <option value="Black">请选择</option>
                </select>
              </div>
            </div>
            <form>
              <div class="numbers-row">
                <input type="text" name="french-hens" id="french-hens" value="1">
                <div class="inc button">+</div>
                <div class="dec button">-</div>
              </div>
            </form>
            <a href="#" class="addtocart2">加入购物车</a>
            <a href="#" class="hart"><i class="fa fa-heart-o" aria-hidden="true"></i></a>
            <a href="#" class="hart"><i class="fa fa-sliders" aria-hidden="true"></i></a>

            <div class="share">
              <ul>
                <li>Share:</li>
                <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                <li><a href="#"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
                <li><a href="#"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
              </ul>
            </div>

          </div>
          <!-- /.pro-text -->
        </div>
      </div>
    </div>

  </section>
  <!-- / product-bg -->

  <!-- .grid-shop -->
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <img v-if="product.categroy_id===3" src="https://img.hogonmr.cn/ornaments.png?imageView2/0/w/1100" alt="2"
             style="margin-bottom: 30px;"/>
        <img v-if="product.categroy_id===2" src="https://img.hogonmr.cn/clothes.png?imageView2/0/w/1100" alt="2"
             style="margin-bottom: 30px;"/>
        <img v-if="product.categroy_id===1" src="https://img.hogonmr.cn/shoes.png?imageView2/0/w/1100" alt="2"
             style="margin-bottom: 30px;"/>
      </div>
      <div class="col-md-6 col-sm-12">
        <img src="https://img.hogonmr.cn/packing.png?imageView2/0/w/1100" alt="2" style="margin-bottom: 30px;"/>
      </div>
      <div class="col-md-6 col-sm-12" v-for="(item, index) in product.imgs">
        <img :src="'https://img.hogonmr.cn/product/'+item+'?imageView2/0/w/1100'" alt="2" style="margin-bottom: 30px;"/>
      </div>
    </div>
  </div>
  <!-- /.grid-shop -->

  <br/>
  <!-- 相关产品   -->
  <section>
    <!-- .Related Products -->
    <div class="container">
      <div class="tittle text-center">
        <h2>您可能会喜欢</h2>
      </div>
      <div class="row">
        <div class="row wow zoomIn  animated" data-wow-duration=".5s" data-wow-delay=".2s">
          <div class="col-md-4">
            <!-- .pro-text -->
            <router-link to="/goods?id=7">
              <div class="pro-text">

                <div class="pro-img"><img src="https://img.hogonmr.cn/product/0H0A3215.jpg?imageView2/0/w/460" alt="2">

                </div>
                <a href="#">HM 束脚休闲裤白</a> <a href="#" class="addtocart">+ 加入购物车</a>
                <div class="price">¥2,280</div>
              </div>
            </router-link>
          </div>

          <div class="col-md-4">
            <!-- .pro-text -->
            <router-link to="/goods?id=4">
              <div class="pro-text">

                <div class="pro-img"><img src="https://img.hogonmr.cn/product/IMG4_3313.jpg?imageView2/0/w/460" alt="2">

                </div>
                <a href="#">HM C 字母棒球帽黑</a> <a href="#" class="addtocart">+ 加入购物车</a>
                <div class="price">¥599</div>
              </div>
            </router-link>
          </div>

          <div class="col-md-4">
            <!-- .pro-text -->
            <router-link to="/goods?id=38">
              <div class="pro-text">

                <div class="pro-img"><img src="https://img.hogonmr.cn/product/0H0A1766.jpg?imageView2/0/w/460" alt="2">

                </div>
                <a href="#">Forrest Gump 经典猫爪休闲鞋纯黄</a> <a href="#" class="addtocart">+ 加入购物车</a>
                <div class="price">¥5,900</div>
              </div>
            </router-link>
          </div>


        </div>
      </div>
    </div>
    <!-- /.Related Products -->
  </section>


</template>

<script>
export default {
  data() {
    return {
      products: [
        {
          id: 1,
          title: "MINI TCOS",
          subtitle: "锁头手提包",
          cover: "0101.jpg",
          price: "2,680",
          origin_price: "5700",
          categroy_id: 3,
          imgs: [
            "0101.jpg", "0102.jpg", "0103.jpg", "0104.jpg", "0105.jpg", "0106.jpg", "0107.jpg"
          ]
        },
        {
          id: 2,
          title: "HM",
          subtitle: "ABC 字母棒球帽黑",
          cover: "0201.jpg",
          price: "599",
          origin_price: "999",
          categroy_id: 3,
          imgs: [
            "0201.jpg", "0202.jpg", "0203.jpg", "0204.jpg", "0205.jpg"
          ]
        },
        {
          id: 3,
          title: "HM",
          subtitle: "ABC 字母棒球帽白",
          cover: "0301.jpg",
          price: "599",
          origin_price: "999",
          categroy_id: 3,
          imgs: [
            "0301.jpg", "0302.jpg", "0303.jpg", "0304.jpg", "0305.jpg"
          ]
        },
        {
          id: 4,
          title: "HM",
          subtitle: "C 字母棒球帽黑",
          cover: "IMG4_3313.jpg",
          price: "599",
          origin_price: "999",
          categroy_id: 3,
          imgs: [
            "IMG4_3313.jpg", "IMG4_3314.jpg", "IMG4_3315.jpg", "IMG4_3316.jpg", "IMG4_3317.jpg"
          ]
        },
        {
          id: 5,
          title: "HM",
          subtitle: "B 字母棒球帽白",
          cover: "IMG_3308.jpg",
          price: "599",
          origin_price: "999",
          categroy_id: 3,
          imgs: [
            "IMG_3308.jpg", "IMG_3309.jpg", "IMG_3311.jpg", "IMG_3312.jpg", "IMG_3313.jpg"
          ]
        },
        {
          id: 6,
          title: "HM",
          subtitle: "束脚休闲裤绿",
          cover: "0H0A3231.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3231.jpg", "0H0A3232.jpg", "0H0A3233.jpg", "0H0A3234.jpg", "0H0A3235.jpg", "0H0A3236.jpg", "0H0A3237.jpg", "0H0A3238.jpg"
          ]
        },
        {
          id: 7,
          title: "HM",
          subtitle: "束脚休闲裤白",
          cover: "0H0A3215.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3215.jpg", "0H0A3216.jpg", "0H0A3217.jpg", "0H0A3218.jpg", "0H0A3219.jpg", "0H0A3220.jpg", "0H0A3221.jpg"
          ]
        },
        {
          id: 8,
          title: "HM",
          subtitle: "束脚休闲裤灰",
          cover: "0H0A3223.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3223.jpg", "0H0A3224.jpg", "0H0A3225.jpg", "0H0A3226.jpg", "0H0A3227.jpg", "0H0A3228.jpg", "0H0A3229.jpg", "0H0A3230.jpg"
          ]
        },
        {
          id: 9,
          title: "HM",
          subtitle: "豹纹打底裤",
          cover: "0H0A3206.jpg",
          price: "1,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3206.jpg", "0H0A3207.jpg", "0H0A3209.jpg", "0H0A3210.jpg", "0H0A3211.jpg", "0H0A3212.jpg", "0H0A3213.jpg"
          ]
        },
        {
          id: 10,
          title: "HM",
          subtitle: "经典打底裤黑",
          cover: "0H0A3183.jpg",
          price: "1,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3183.jpg", "0H0A3184.jpg", "0H0A3185.jpg", "0H0A3186.jpg", "0H0A3189.jpg", "0H0A3190.jpg", "0H0A3193.jpg", "0H0A3194.jpg"
          ]
        },
        {
          id: 11,
          title: "2023春夏「TIGER」",
          subtitle: "油蜡老虎图案 T 恤绿",
          cover: "0H0A3094.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3094.jpg", "0H0A3095.jpg", "0H0A3096.jpg", "0H0A3097.jpg", "0H0A3098.jpg", "0H0A3099.jpg", "0H0A3100.jpg", "0H0A3102.jpg", "0H0A3103.jpg", "0H0A3104.jpg"
          ]
        },
        {
          id: 12,
          title: "2023春夏「TIGER」",
          subtitle: "油蜡老虎图案 T 恤黑",
          cover: "0H0A3135.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3135.jpg", "0H0A3136.jpg", "0H0A3137.jpg", "0H0A3138.jpg", "0H0A3139.jpg", "0H0A3140.jpg", "0H0A3141.jpg", "0H0A3142.jpg", "0H0A3144.jpg", "0H0A3145.jpg"
          ]
        },
        {
          id: 13,
          title: "2023春夏「TIGER」",
          subtitle: "油蜡老虎图案 T 恤白",
          cover: "IMG_6592.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "IMG_6592.jpg", "IMG_6593.jpg", "IMG_6595.jpg", "IMG_6596.jpg", "IMG_6597.jpg", "IMG_6598.jpg", "IMG_6599.jpg", "IMG_6600.jpg", "IMG_6601.jpg", "IMG_6602.jpg"
          ]
        },
        {
          id: 14,
          title: "HM CARTOON",
          subtitle: "经典格子小熊 T 恤绿",
          cover: "_MG_3228.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "_MG_3228.jpg", "0H0A2273.jpg", "0H0A2274.jpg", "0H0A2275.jpg", "0H0A2276.jpg", "0H0A2277.jpg", "0H0A2278.jpg", "0H0A2279.jpg"
          ]
        },
        {
          id: 15,
          title: "HM CARTOON",
          subtitle: "经典格子小熊 T 恤白",
          cover: "0H0A2261.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A2261.jpg", "0H0A2262.jpg", "0H0A2263.jpg", "0H0A2264.jpg", "0H0A2266.jpg", "0H0A2267.jpg", "0H0A2268.jpg", "0H0A2269.jpg"
          ]
        },
        {
          id: 16,
          title: "2023春夏「TIGER」",
          subtitle: "立体虎头图案 T 恤绿",
          cover: "0H0A3082.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3082.jpg", "0H0A3083.jpg", "0H0A3084.jpg", "0H0A3085.jpg", "0H0A3087.jpg", "0H0A3089.jpg", "0H0A3090.jpg", "0H0A3091.jpg", "0H0A3092.jpg", "0H0A3093.jpg"
          ]
        },
        {
          id: 17,
          title: "2023春夏「TIGER」",
          subtitle: "立体虎头图案 T 恤黑",
          cover: "0H0A3121.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3121.jpg", "0H0A3123.jpg", "0H0A3124.jpg", "0H0A3126.jpg", "0H0A3127.jpg", "0H0A3128.jpg", "0H0A3129.jpg", "0H0A3130.jpg", "0H0A3132.jpg", "0H0A3133.jpg"
          ]
        },
        {
          id: 18,
          title: "2023春夏「TIGER」",
          subtitle: "立体虎头图案 T 恤白",
          cover: "0H0A3148.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3148.jpg", "0H0A3149.jpg", "0H0A3150.jpg", "0H0A3152.jpg", "0H0A3153.jpg", "0H0A3154.jpg", "0H0A3155.jpg", "0H0A3156.jpg"
          ]
        },
        {
          id: 19,
          title: "HM CARTOON ",
          subtitle: "立体小熊图案 T 恤绿",
          cover: "IMG_6556.jpg",
          price: "1,880",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "IMG_6556.jpg", "IMG_6557.jpg", "IMG_6558.jpg", "IMG_6559.jpg", "IMG_6560.jpg", "IMG_6561.jpg", "IMG_6562.jpg", "IMG_6563.jpg", "IMG_6564.jpg", "IMG_6565.jpg"
          ]
        },
        {
          id: 20,
          title: "HM CARTOON ",
          subtitle: "立体小熊图案 T 恤黑",
          cover: "IMG_6568.jpg",
          price: "1,880",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "IMG_6568.jpg", "IMG_6569.jpg", "IMG_6570.jpg", "IMG_6571.jpg", "IMG_6572.jpg", "IMG_6574.jpg", "IMG_6575.jpg", "IMG_6576.jpg"
          ]
        },
        {
          id: 21,
          title: "HM CARTOON ",
          subtitle: "立体小熊图案 T 恤白",
          cover: "IMG_6580.jpg",
          price: "1,880",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "IMG_6580.jpg", "IMG_6582.jpg", "IMG_6583.jpg", "IMG_6584.jpg", "IMG_6585.jpg", "IMG_6586.jpg", "IMG_6587.jpg", "IMG_6588.jpg", "IMG_6589.jpg", "IMG_6590.jpg"
          ]
        },
        {
          id: 22,
          title: "HM CARTOON",
          subtitle: "复古老花小熊 T 恤绿",
          cover: "_MG_32280.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "_MG_32280.jpg", "0H0A2282.jpg", "0H0A2283.jpg", "0H0A2284.jpg", "0H0A2285.jpg", "0H0A2286.jpg", "0H0A2287.jpg", "0H0A2288.jpg"
          ]
        },
        {
          id: 23,
          title: "HM CARTOON",
          subtitle: "复古老花小熊 T 恤黑",
          cover: "0H0A2291.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A2291.jpg", "0H0A2292.jpg", "0H0A2293.jpg", "0H0A2294.jpg", "0H0A2295.jpg", "0H0A2297.jpg", "0H0A2299.jpg", "0H0A2300.jpg"
          ]
        },
        {
          id: 24,
          title: "HM CARTOON",
          subtitle: "复古老花小熊 T 恤白",
          cover: "0H0A2303.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A2303.jpg", "0H0A2304.jpg", "0H0A2305.jpg", "0H0A2306.jpg", "0H0A2307.jpg", "0H0A2309.jpg", "0H0A2310.jpg", "0H0A2311.jpg"
          ]
        },
        {
          id: 25,
          title: "HM 经典",
          subtitle: "可爱呆萌脸 T 恤橙",
          cover: "0H0A3035.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3035.jpg", "0H0A3036.jpg", "0H0A3037.jpg", "0H0A3038.jpg", "0H0A3039.jpg", "0H0A3040.jpg", "0H0A3041.jpg", "0H0A3042.jpg", "0H0A3043.jpg", "0H0A3044.jpg", "0H0A3045.jpg", "0H0A3046.jpg"
          ]
        },
        {
          id: 26,
          title: "HM 经典",
          subtitle: "可爱呆萌脸 T 恤黑",
          cover: "0H0A3050.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3050.jpg", "0H0A3051.jpg", "0H0A3052.jpg", "0H0A3053.jpg", "0H0A3055.jpg", "0H0A3056.jpg", "0H0A3057.jpg", "0H0A3059.jpg", "0H0A3060.jpg", "0H0A3062.jpg", "0H0A3063.jpg", "0H0A3064.jpg"
          ]
        },
        {
          id: 27,
          title: "HM 经典",
          subtitle: "拆卸小熊图案 T 恤黑",
          cover: "0H0A3106.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3106.jpg", "0H0A3107.jpg", "0H0A3109.jpg", "0H0A3110.jpg", "0H0A3111.jpg", "0H0A3113.jpg", "0H0A3114.jpg", "0H0A3116.jpg", "0H0A3119.jpg", "0H0A3120.jpg"
          ]
        },
        {
          id: 28,
          title: "HM 经典",
          subtitle: "拆卸小熊图案 T 恤白",
          cover: "0H0A3159.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3159.jpg", "0H0A3160.jpg", "0H0A3161.jpg", "0H0A3163.jpg", "0H0A3164.jpg", "0H0A3165.jpg", "0H0A3166.jpg", "0H0A3168.jpg", "0H0A3169.jpg", "0H0A3170.jpg"
          ]
        },
        {
          id: 29,
          title: "HM 经典",
          subtitle: "可爱熊猫图案 T 恤橙",
          cover: "0H0A3003.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3003.jpg", "0H0A3004.jpg", "0H0A3005.jpg", "0H0A3006.jpg", "0H0A3009.jpg", "0H0A3010.jpg", "0H0A3011.jpg", "0H0A3012.jpg", "0H0A3013.jpg", "0H0A3014.jpg", "0H0A3016.jpg", "0H0A3017.jpg", "0H0A3018.jpg"
          ]
        },
        {
          id: 30,
          title: "HM 经典",
          subtitle: "可爱熊猫图案 T 恤白",
          cover: "0H0A3020.jpg",
          price: "2,280",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3020.jpg", "0H0A3021.jpg", "0H0A3022.jpg", "0H0A3023.jpg", "0H0A3024.jpg", "0H0A3025.jpg", "0H0A3026.jpg", "0H0A3027.jpg", "0H0A3029.jpg", "0H0A3030.jpg", "0H0A3031.jpg", "0H0A3032.jpg", "0H0A3033.jpg"
          ]
        },
        {
          id: 31,
          title: "HM 经典",
          subtitle: "立体海豚毛衣绿",
          cover: "0H0A3175.jpg",
          price: "2,880",
          origin_price: "5700",
          categroy_id: 2,
          imgs: [
            "0H0A3175.jpg", "0H0A3176.jpg", "0H0A3177.jpg", "0H0A3178.jpg", "0H0A3179.jpg", "0H0A3180.jpg", "0H0A3181.jpg"
          ]
        },
        {
          id: 32,
          title: "HM CAT PAW",
          subtitle: "经典猫爪休闲鞋白兰",
          cover: "IMG_2299.jpg",
          price: "4,880",
          origin_price: "5700",
          categroy_id: 1,
          imgs: [
            "IMG_2299.jpg", "IMG_2300.jpg", "IMG_2301.jpg", "IMG_2303.jpg", "IMG_2304.jpg"
          ]
        },
        {
          id: 33,
          title: "HM CAT PAW",
          subtitle: "经典猫爪休闲鞋纯白",
          cover: "IMG_2340.jpg",
          price: "4,880",
          origin_price: "5700",
          categroy_id: 1,
          imgs: [
            "IMG_2340.jpg", "IMG_2341.jpg", "IMG_2343.jpg", "IMG_2344.jpg", "IMG_2347.jpg"
          ]
        },
        {
          id: 34,
          title: "HM WHITE",
          subtitle: "经典休闲运动鞋白",
          cover: "_MG_9230.jpg",
          price: "5,600",
          origin_price: "5700",
          categroy_id: 1,
          imgs: [
            "_MG_9230.jpg", "_MG_9232.jpg", "_MG_9233.jpg", "_MG_9234.jpg", "_MG_9235.jpg"
          ]
        },
        {
          id: 35,
          title: "Forrest Gump",
          subtitle: "经典猫爪休闲鞋纯白",
          cover: "IMG_2294.jpg",
          price: "5,900",
          origin_price: "5700",
          categroy_id: 1,
          imgs: [
            "IMG_2294.jpg", "IMG_2295.jpg", "IMG_2296.jpg", "IMG_2297.jpg", "IMG_2298.jpg"
          ]
        },
        {
          id: 36,
          title: "Forrest Gump",
          subtitle: "经典猫爪休闲鞋纯红",
          cover: "IMG_2276.jpg",
          price: "5,900",
          origin_price: "5700",
          categroy_id: 1,
          imgs: [
            "IMG_2276.jpg", "IMG_2277.jpg", "IMG_2279.jpg", "IMG_2280.jpg", "IMG_2281.jpg"
          ]
        },
        {
          id: 37,
          title: "Forrest Gump",
          subtitle: "经典猫爪休闲鞋纯蓝",
          cover: "IMG_2289.jpg",
          price: "5,900",
          origin_price: "5700",
          categroy_id: 1,
          imgs: [
            "IMG_2289.jpg", "IMG_2290.jpg", "IMG_2291.jpg", "IMG_2292.jpg", "IMG_2293.jpg"
          ]
        },
        {
          id: 38,
          title: "Forrest Gump",
          subtitle: "经典猫爪休闲鞋纯黄",
          cover: "0H0A1766.jpg",
          price: "5,900",
          origin_price: "5700",
          categroy_id: 1,
          imgs: [
            "0H0A1766.jpg", "0H0A1767.jpg", "0H0A1768.jpg", "0H0A1777.jpg", "0H0A1780.jpg"
          ]
        },

        {
          id: 39,
          title: "HM 时尚",
          subtitle: "铆钉休闲鞋",
          cover: "cover/39.png",
          price: "6,980",
          origin_price: "8900",
          categroy_id: 1,
          imgs: [
            "3901.jpg", "3902.jpg", "3903.jpg", "3904.jpg", "3905.jpg", "3906.jpg", "3907.jpg"
          ]
        },
        {
          id: 40,
          title: "HM 经典",
          subtitle: "立体老虎T恤白",
          cover: "cover/40.png",
          price: "2,680",
          origin_price: "2980",
          categroy_id: 2,
          imgs: [
            "4001.png", "4002.png", "4003.png", "4004.png", "4005.png", "4006.png", "4007.png", "4008.png", "4009.png", "4010.png"
          ]
        },
        {
          id: 41,
          title: "HM 经典",
          subtitle: "卡通字母T恤橙",
          cover: "cover/41.png",
          price: "2,480",
          origin_price: "2680",
          categroy_id: 2,
          imgs: [
            "4101.png", "4102.png", "4103.png", "4104.png", "4105.png", "4106.png", "4107.png"
          ]
        },
        {
          id: 42,
          title: "HM 新款",
          subtitle: "鱼骨T恤白",
          cover: "cover/42.png",
          price: "2,680",
          origin_price: "2980",
          categroy_id: 2,
          imgs: [
            "4201.jpg", "4202.jpg", "4203.jpg", "4204.png", "4205.png", "4206.png", "4207.png", "4208.png", "4209.png", "4210.png"
          ]
        },
        {
          id: 43,
          title: "HM 新款",
          subtitle: "时尚羊皮小白鞋银白",
          cover: "cover/43.png",
          price: "6,300",
          origin_price: "6800",
          categroy_id: 1,
          imgs: [
            "4301.jpg", "4302.jpg", "4303.jpg", "4304.jpg", "4305.jpg", "4306.jpg", "4307.jpg", "4308.jpg"
          ]
        },
        {
          id: 44,
          title: "HM 经典",
          subtitle: "立体老虎T恤绿",
          cover: "cover/44.png",
          price: "2,680",
          origin_price: "2980",
          categroy_id: 2,
          imgs: [
            "4401.png", "4402.png", "4403.png", "4404.png", "4405.png", "4406.png", "4407.png", "4408.png", "4409.png"
          ]
        },
        {
          id: 45,
          title: "HM 新款",
          subtitle: "蓝标平底板鞋",
          cover: "cover/45.png",
          price: "6,800",
          origin_price: "7900",
          categroy_id: 1,
          imgs: [
            "4501.jpg", "4502.jpg", "4503.jpg", "4504.jpg", "4505.jpg", "4506.jpg", "4507.jpg", "4508.jpg"
          ]
        },
        {
          id: 46,
          title: "HM 经典",
          subtitle: "卡通字母T恤黑",
          cover: "cover/46.png",
          price: "2,480",
          origin_price: "2680",
          categroy_id: 2,
          imgs: [
            "4601.png", "4602.png", "4603.png", "4604.png", "4605.png", "4606.png", "4607.png"
          ]
        },
        {
          id: 47,
          title: "HM 新款",
          subtitle: "时尚羊皮小白鞋珠光银",
          cover: "cover/47.png",
          price: "6,300",
          origin_price: "6800",
          categroy_id: 1,
          imgs: [
            "4701.jpg", "4702.jpg", "4703.jpg", "4704.jpg", "4705.jpg", "4706.jpg", "4707.jpg"
          ]
        },
        {
          id: 48,
          title: "HM 经典",
          subtitle: "立体老虎T恤紫 ",
          cover: "cover/48.png",
          price: "2,680",
          origin_price: "2980",
          categroy_id: 2,
          imgs: [
            "4801.png", "4802.png", "4803.png", "4804.png", "4805.png", "4806.png", "4807.png", "4808.png", "4809.png"
          ]
        },
        {
          id: 49,
          title: "HM 新款",
          subtitle: "时尚羊皮小白鞋黑白",
          cover: "cover/49.png",
          price: "6,300",
          origin_price: "6800",
          categroy_id: 1,
          imgs: [
            "4901.jpg", "4902.jpg", "4903.jpg", "4904.jpg", "4905.jpg", "4906.jpg", "4907.jpg"
          ]
        },
        {
          id: 50,
          title: "HM 新款",
          subtitle: "鱼骨T恤黑",
          cover: "cover/50.png",
          price: "2,680",
          origin_price: "2980",
          categroy_id: 2,
          imgs: [
            "5001.png", "5002.png", "5003.png", "5004.png", "5005.png", "5006.png", "5007.png", "5008.png"
          ]
        },
        {
          id: 51,
          title: "HM 经典",
          subtitle: "立体老虎T恤黑",
          cover: "cover/51.png",
          price: "2,680",
          origin_price: "2980",
          categroy_id: 2,
          imgs: [
            "5101.png", "5102.png", "5103.png", "5104.png", "5105.png", "5106.png", "5107.png", "5108.png"
          ]
        },
        {
          id: 52,
          title: "HM 新款",
          subtitle: "新款鱼骨T恤绿",
          cover: "cover/52.png",
          price: "2,680",
          origin_price: "2980",
          categroy_id: 2,
          imgs: [
            "5201.png", "5202.png", "5203.png", "5204.png", "5205.png", "5206.png", "5207.png", "5208.png", "5209.png"
          ]
        },
        {
          id: 53,
          title: "HM",
          subtitle: "时尚铆钉休闲鞋",
          cover: "cove/53.png",
          price: "6,300",
          origin_price: "8900",
          categroy_id: 1,
          imgs: [
            "5300.png", "5301.png", "5302.png", "5303.png", "5304.png", "5305.png", "5306.png", "5307.png"
          ]
        },
        {
          id: 54,
          title: "HM",
          subtitle: "AW字母火龙果T恤",
          cover: "cove/54.png",
          price: "2,980",
          origin_price: "2980",
          categroy_id: 1,
          imgs: [
            "5400.png", "5401.png", "5402.png", "5403.png", "5404.png", "5405.png", "5406.png", "5407.png"
          ]
        },
        {
          id: 55,
          title: "MIU 经典款",
          subtitle: "火龙果字母T恤",
          cover: "cover/55.png",
          price: "2,980",
          origin_price: "2980",
          categroy_id: 1,
          imgs: [
            "5501.png", "5502.png", "5503.png", "5504.png", "5505.png", "5506.png", "5507.png", "5508.png"
          ]
        },
        {
          id: 56,
          title: "MIU 经典款",
          subtitle: "白色字母T恤",
          cover: "cover/56.png",
          price: "2,980",
          origin_price: "2980",
          categroy_id: 1,
          imgs: [
            "5601.png", "5602.png", "5603.png", "5604.png", "5605.png", "5606.png", "5607.png", "5608.png"
          ]
        },
        {
          id: 57,
          title: "HM 新款",
          subtitle: "火龙果魔术贴老爹鞋",
          cover: "cover/57.png",
          price: "8,760",
          origin_price: "8760",
          categroy_id: 1,
          imgs: [
            "5701.png", "5702.png", "5703.png", "5704.png", "5705.png", "5706.png", "5707.png"
          ]
        },

        {
          id:61,
          title:"HOGON MR",
          subtitle:"字母刺绣百搭鸭舌帽",
          cover:"cover/61.png",
          price:"599",
          origin_price:"599",
          categroy_id:1,
          imgs:[
            "6100.png","6101.png","6102.png","6103.png"
          ]
        },
        {
          id:60,
          title:"HOGON MR",
          subtitle:"高定情侣经典束脚休闲裤",
          cover:"cover/60.png",
          price:"2,680",
          origin_price:"5700",
          categroy_id:1,
          imgs:[
            "6000.png","6001.png","6002.png","6003.png"
          ]
        },
        {
          id:58,
          title:"MIU 经典款",
          subtitle:"字母休闲拼色T恤",
          cover:"cover/58a.png",
          price:"2,980",
          origin_price:"2980",
          categroy_id:1,
          imgs:[
            "5800.png","5801.png","5802.png","5803.png","5804.png","5805.png","5806.png","5807.png","5808.png,5809.png"
          ]
        },
        {
          id:59,
          title:"",
          subtitle:"经典复古潮流时尚平底板鞋",
          cover:"cover/57a.png",
          price:"6,980",
          origin_price:"6980",
          categroy_id:1,
          imgs:[
            "57_01.png","57_02.png","57_03.png","57_04.png","57_05.png"
          ]
        },
        {
          id:64,
          title:"HOGON MR",
          subtitle:"土星休闲T恤",
          cover:"cover/64.png",
          price:"3280",
          origin_price:"3280",
          categroy_id:1,
          imgs:[
            "6401.png","6402.png","6403.png","6404.png","6405.png"
          ]
        },
        {
          id:63,
          title:"HOGON MR",
          subtitle:"经典黑白格子条纹裤",
          cover:"cover/63.png",
          price:"2680",
          origin_price:"2680",
          categroy_id:1,
          imgs:[
            "6301.png"
          ]
        },
        {
          id:62,
          title:"HOGON MR",
          subtitle:"复古做旧德训鞋",
          cover:"cover/62.png",
          price:"6300",
          origin_price:"6300",
          categroy_id:1,
          imgs:[
            "6201.png","6202.png","6203.png"
          ]
        },
      ],
      product: {}
    }
  },
  created() {
    this.getProductDetail()
  },
  methods: {
    async getProductDetail() {
      const id = this.$route.query.id

      const result = this.products.find(function (item, index, arr) {
        return item.id == id
      })
      this.product = result
    }
  }
}
</script>

<style>

</style>
